import { createBrowserHistory } from "history";

const currentHistory = createBrowserHistory();

export default currentHistory;
